/* Grid Lock Floors header: mega menu, live search, sticky bar, mobile menu (7-10-2026) */
(function () {
  var wrap = document.querySelector('[data-glh]');
  if (!wrap) return;
  var bar = wrap.querySelector('[data-glh-bar]');
  var spacer = wrap.querySelector('[data-glh-spacer]');
  var nav = wrap.querySelector('[data-glh-nav]');
  var scrim = wrap.querySelector('[data-glh-scrim]');
  var mq = window.matchMedia('(max-width: 960px)');
  var items = Array.prototype.slice.call(wrap.querySelectorAll('[data-glh-mi]'));

  /* ---------- mega menu ---------- */
  var openTimer, closeTimer;
  function setOpen(li, on) {
    li.classList.toggle('open', on);
    var t = li.querySelector('[data-glh-t]');
    if (t) t.setAttribute('aria-expanded', on ? 'true' : 'false');
  }
  function closeAll(except) {
    items.forEach(function (li) { if (li !== except) setOpen(li, false); });
    if (!mq.matches) scrim.hidden = !except;
  }
  items.forEach(function (li) {
    var t = li.querySelector('[data-glh-t]');
    if (!t) return;
    t.addEventListener('click', function (e) {
      e.preventDefault();
      var on = !li.classList.contains('open');
      if (mq.matches) { setOpen(li, on); return; }
      closeAll(on ? li : null);
      setOpen(li, on);
    });
    li.addEventListener('mouseenter', function () {
      if (mq.matches || !(window.matchMedia('(hover: hover)').matches)) return;
      clearTimeout(closeTimer); clearTimeout(openTimer);
      openTimer = setTimeout(function () { closeAll(li); setOpen(li, true); }, 120);
    });
    li.addEventListener('mouseleave', function () {
      if (mq.matches) return;
      clearTimeout(openTimer);
      closeTimer = setTimeout(function () { setOpen(li, false); scrim.hidden = !items.some(function (x) { return x.classList.contains('open'); }); }, 220);
    });
  });
  scrim.addEventListener('click', function () { closeAll(null); });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = items.filter(function (li) { return li.classList.contains('open'); })[0];
    if (nav.classList.contains('open')) { closeMenu(); return; }
    if (open) { closeAll(null); var t = open.querySelector('[data-glh-t]'); if (t) t.focus(); }
  });
  document.addEventListener('click', function (e) {
    if (!mq.matches && !nav.contains(e.target)) closeAll(null);
  });

  /* ---------- mobile full-screen menu ---------- */
  var openBtn = wrap.querySelector('[data-glh-open]');
  var closeBtn = wrap.querySelector('[data-glh-close]');
  function openMenu() {
    nav.classList.add('open'); document.body.classList.add('glh-lock');
    openBtn.setAttribute('aria-expanded', 'true');
    if (closeBtn) closeBtn.focus();
  }
  function closeMenu() {
    nav.classList.remove('open'); document.body.classList.remove('glh-lock');
    openBtn.setAttribute('aria-expanded', 'false');
    openBtn.focus();
  }
  if (openBtn) openBtn.addEventListener('click', openMenu);
  if (closeBtn) closeBtn.addEventListener('click', closeMenu);
  mq.addEventListener ? mq.addEventListener('change', reset) : mq.addListener(reset);
  function reset() { closeAll(null); nav.classList.remove('open'); document.body.classList.remove('glh-lock'); scrim.hidden = true; }

  /* ---------- sticky bar ---------- */
  var stuck = false, ticking = false;
  function limit() { return wrap.offsetTop + wrap.querySelector('.glf-top').offsetHeight + bar.offsetHeight; }
  function onScroll() {
    ticking = false;
    var y = window.pageYOffset || document.documentElement.scrollTop;
    var go = y > limit() + 40;
    if (go === stuck) return;
    if (go) spacer.style.height = bar.offsetHeight + 'px';
    stuck = go;
    wrap.classList.toggle('is-stuck', go);
    if (!go) spacer.style.height = '';
  }
  window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
  onScroll();

  /* ---------- live search ---------- */
  var form = wrap.querySelector('[data-glh-search]');
  var q = wrap.querySelector('[data-glh-q]');
  var box = wrap.querySelector('[data-glh-sugg]');
  if (!form || !q || !box) return;
  var fmt = form.getAttribute('data-money') || '£{{amount}}';
  var cache = {}, timer, last = '', sel = -1;
  function money(v) {
    var n = parseFloat(v); if (!isFinite(n)) return '';
    var amt = n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amt).replace(/<[^>]+>/g, '');
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]; }); }
  function hl(title, term) {
    var t = esc(title.split('|')[0].trim());
    var words = term.trim().split(/\s+/).filter(function (w) { return w.length > 1; }).map(function (w) { return w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); });
    if (!words.length) return t;
    return t.replace(new RegExp('(' + words.join('|') + ')', 'gi'), '<mark>$1</mark>');
  }
  function img(src, w) { if (!src) return '<img alt="" src="data:image/gif;base64,R0lGODlhAQABAAAAACw=">'; return '<img alt="" loading="lazy" src="' + esc(src) + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w + '">'; }
  function show(on) { box.hidden = !on; q.setAttribute('aria-expanded', on ? 'true' : 'false'); if (!on) { sel = -1; q.removeAttribute('aria-activedescendant'); } }
  function render(term, r) {
    var res = (r && r.resources && r.resources.results) || {};
    var P = res.products || [], C = res.collections || [], A = (res.articles || []).concat(res.pages || []);
    var h = '', i = 0;
    if (P.length) {
      h += '<div class="glh-sugg__h">Products</div>';
      P.forEach(function (p) {
        var pr = (p.price_max && p.price_min && p.price_max !== p.price_min ? 'from ' : '') + money(p.price_min || p.price);
        h += '<a role="option" id="glh-o' + (i++) + '" href="' + esc(p.url) + '">' + img(p.featured_image && p.featured_image.url || p.image, 120) + '<span class="glh-sugg__t">' + hl(p.title, term) + '</span><span class="glh-sugg__p">' + esc(pr) + '</span></a>';
      });
    }
    if (C.length) {
      h += '<div class="glh-sugg__h">Categories</div>';
      C.forEach(function (c) { h += '<a role="option" id="glh-o' + (i++) + '" href="' + esc(c.url) + '"><span class="glh-sugg__t">' + hl(c.title, term) + '</span></a>'; });
    }
    if (A.length) {
      h += '<div class="glh-sugg__h">Guides &amp; pages</div>';
      A.slice(0, 4).forEach(function (a) { h += '<a role="option" id="glh-o' + (i++) + '" href="' + esc(a.url) + '"><span class="glh-sugg__t">' + hl(a.title, term) + '</span></a>'; });
    }
    if (!i) h += '<div class="glh-sugg__none">No matches for “' + esc(term) + '”. Try “10mm”, “ramp” or a colour.</div>';
    h += '<a role="option" id="glh-o' + (i++) + '" class="glh-sugg__all" href="' + form.action + '?q=' + encodeURIComponent(term) + '&options%5Bprefix%5D=last">See all results for “' + esc(term) + '”</a>';
    box.innerHTML = h; sel = -1; show(true);
  }
  function fetchS(term) {
    if (cache[term]) { render(term, cache[term]); return; }
    var u = '/search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=product,collection,article,page&resources[limit]=6&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,tag';
    fetch(u, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (j) {
      cache[term] = j; if (q.value.trim() === term) render(term, j);
    }).catch(function () { show(false); });
  }
  q.addEventListener('input', function () {
    var term = q.value.trim(); clearTimeout(timer);
    if (term.length < 2) { show(false); last = ''; return; }
    if (term === last) return; last = term;
    timer = setTimeout(function () { fetchS(term); }, 160);
  });
  q.addEventListener('focus', function () { if (q.value.trim().length >= 2 && box.innerHTML) show(true); });
  q.addEventListener('keydown', function (e) {
    if (box.hidden) return;
    var opts = box.querySelectorAll('[role=option]');
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      e.preventDefault();
      sel = e.key === 'ArrowDown' ? Math.min(opts.length - 1, sel + 1) : Math.max(-1, sel - 1);
      Array.prototype.forEach.call(opts, function (o, k) { o.setAttribute('aria-selected', k === sel ? 'true' : 'false'); });
      if (sel > -1) { q.setAttribute('aria-activedescendant', opts[sel].id); opts[sel].scrollIntoView({ block: 'nearest' }); } else q.removeAttribute('aria-activedescendant');
    } else if (e.key === 'Enter' && sel > -1) { e.preventDefault(); window.location.href = opts[sel].href; }
    else if (e.key === 'Escape') { e.stopPropagation(); show(false); }
  });
  document.addEventListener('click', function (e) { if (!form.contains(e.target)) show(false); });
})();
